import { MapSettings } from '../../../types'

const pixelsToReal = (pixels: number, mapSettings: MapSettings) =>
  pixels / mapSettings.scale

const realToPixels = (real: number, mapSettings: MapSettings) =>
  real * mapSettings.scale

const getUnitSingular = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 'ft' : 'm'

const getUnitSquared = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 'sq ft' : 'sq m'

const getDefaultCeilingHeight = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 9 : 2.7

const getDefaultDoorWidth = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 3 : 0.91

const getDefaultDoorHeight = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 6.67 : 2.03

const getDefaultWindowWidth = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 4 : 1.22

const getDefaultWindowHeight = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 3 : 0.91

const getDefaultStepHeight = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 0.58 : 0.18

const getDefaultTreadDepth = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? 0.92 : 0.28

const formatStandardWallThickness = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? '0.5 ft (6 inches)' : '0.15 m (15cm)'

const formatStandardDoorWidth = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? '3 ft (36 inches)' : '0.91 m'

const formatStandardDoorHeight = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? '6.67 ft (80 inches)' : '2.03 m'

const formatStandardWindowWidth = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? '4 ft' : '1.22 m'

const formatStandardWindowHeight = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? '3 ft' : '0.91 m'

const formatStandardStepHeight = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? '7 inches (0.58 ft)' : '18cm'

const formatStandardTreadDepth = (mapSettings: MapSettings) =>
  mapSettings.units === 'feet' ? '11 inches (0.92 ft)' : '28cm'

export {
  pixelsToReal,
  realToPixels,
  getUnitSingular,
  getUnitSquared,
  getDefaultCeilingHeight,
  getDefaultDoorWidth,
  getDefaultDoorHeight,
  getDefaultWindowWidth,
  getDefaultWindowHeight,
  getDefaultStepHeight,
  getDefaultTreadDepth,
  formatStandardWallThickness,
  formatStandardDoorWidth,
  formatStandardDoorHeight,
  formatStandardWindowWidth,
  formatStandardWindowHeight,
  formatStandardStepHeight,
  formatStandardTreadDepth,
}
